// Explore-stats page: Fields of qualifications — current Parliament.
// Recreates the Handbook page — horizontal stacked bar of broad
// qualification fields by party, with a supporting field/total table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatStackedBar } from './charts';

export default function FieldsOfQualifications() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('fields-of-qualifications');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Fields of qualifications — current Parliament"
      description="The broad fields in which current parliamentarians hold their qualifications — a strong concentration in humanities, social sciences and law, and comparatively few in fields such as information technology."
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="fields-of-qualifications"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Field of qualifications — current Parliament
          </Typography>
          <StatStackedBar
            data={charts.by_field_party || []}
            xKey="field"
            keys={charts.series || []}
            layout="vertical"
            height={460}
          />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
